<template>
  <van-popup
    v-model="visible"
    :style="{ height: '70%' }"
    :position="'bottom'"
    :close-on-click-overlay="true"
    :round="true"
    get-container="body"
    @close="handleClose"
  >
    <div class="route-list-popup">
      <!-- 拖拽手柄 -->
      <div class="popup-handle"></div>
      <!-- 标题 -->
      <!-- 路线列表 -->
      <div class="popup-content">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
        <div 
          class="route-item"
          v-for="(route, index) in routeList"
          :key="`route-${route.id || index}`"
          @click="handleRouteClick(route, index)"
        >
            <div class="route-cover">
              <img 
                v-if="route.line_cover" 
                :src="route.line_cover" 
                alt="route cover"
                @error="handleImageError"
              />
              <div v-else class="route-cover-placeholder"></div>
            </div>
            <div class="route-info">
              <div class="route-name">{{ route.name || '未知路线' }}</div>
              <div class="route-county">{{ route.county || '未知地区' }}</div>
              <div 
                class="route-intro" 
                v-if="route.introduction"
                v-html="getPlainText(route.introduction)"
              ></div>
            </div>
          </div>
        </van-list>
        
        <!-- 空状态 -->
        <van-empty 
          v-if="!loading && routeList.length === 0"
          description="暂无旅游路线"
          image="search"
        />
      </div>
    </div>

    <!-- 图片预览弹窗（内部展示路线封面） -->
    <ImagePreviewPopup
      v-model="showPreview"
      :image-list="previewImageList"
      :initial-index="previewIndex"
    />
  </van-popup>
</template>

<script>
import ImagePreviewPopup from './ImagePreviewPopup.vue'

export default {
  name: 'RouteListPopup',
  components: {
    ImagePreviewPopup
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    routeList: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    finished: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPreview: false,
      previewIndex: 0
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    // 筛选出有封面的路线列表
    previewImageList() {
      return this.routeList.filter(route => route && route.line_cover)
    }
  },
  methods: {
    handleClose() {
      this.$emit('input', false)
    },
    handleRouteClick(route, index) {
      // 内部预览图片
      if (route && route.line_cover) {
        // 找到该路线在有封面列表中的索引
        const imageList = this.previewImageList
        const imageIndex = imageList.findIndex(item => item.id === route.id)
        if (imageIndex !== -1) {
          this.previewIndex = imageIndex
          this.showPreview = true
        }
      }
      // 保持对外事件，兼容现有调用方
      this.$emit('route-click', route)
    },
    onLoad() {
      // 触发加载更多事件
      this.$emit('load-more')
    },
    handleImageError(event) {
      // 图片加载失败时隐藏图片
      event.target.style.display = 'none'
    },
    getPlainText(html) {
      // 将 HTML 转换为纯文本，只显示前100个字符
      if (!html) return ''
      const div = document.createElement('div')
      div.innerHTML = html
      const text = div.textContent || div.innerText || ''
      return text.length > 100 ? text.substring(0, 100) + '...' : text
    }
  }
}
</script>

<style scoped>
.route-list-popup {
  height: 100%;
  width: 10rem;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 0 20px;
}

.popup-handle {
  width: 60px;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 3px;
  margin: 12px auto;
}

.popup-header {
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
}

.header-title {
  font-size: 36px;
  font-weight: 500;
  color: #333;
  text-align: center;
}

.popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px 0;
}

.route-item {
  display: flex;
  gap: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.route-item:active {
  background-color: #f5f5f5;
}

.route-item:last-child {
  border-bottom: none;
}

.route-cover {
  width: 160px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #f0f0f0;
}

.route-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.route-cover-placeholder {
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 24px;
}

.route-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.route-name {
  font-size: 32px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
}

.route-intro {
  font-size: 26px;
  color: #666;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* van-list 样式 */
:deep(.van-list__finished-text),
:deep(.van-list__loading) {
  padding: 16px 0;
  text-align: center;
  color: #969799;
  font-size: 28px;
}
</style>

